"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEditorReturnFocus = exports.instanceTransformer = exports.initializeEditorConfig = exports.getEditorCommands = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extensionBlockquote = _interopRequireDefault(require("@tiptap/extension-blockquote"));

var _extensionColor = require("@tiptap/extension-color");

var _extensionHighlight = _interopRequireDefault(require("@tiptap/extension-highlight"));

var _extensionLink = _interopRequireWildcard(require("@tiptap/extension-link"));

var _extensionPlaceholder = _interopRequireDefault(require("@tiptap/extension-placeholder"));

var _extensionTableCell = _interopRequireDefault(require("@tiptap/extension-table-cell"));

var _extensionTableHeader = _interopRequireDefault(require("@tiptap/extension-table-header"));

var _extensionTableRow = _interopRequireDefault(require("@tiptap/extension-table-row"));

var _extensionTextAlign = _interopRequireDefault(require("@tiptap/extension-text-align"));

var _extensionUnderline = _interopRequireDefault(require("@tiptap/extension-underline"));

var _starterKit = _interopRequireDefault(require("@tiptap/starter-kit"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _constants = require("./constants");

var _clipboard = require("./custom-extensions/clipboard");

var _customFontColor = require("./custom-extensions/customFontColor");

var _customHighlight = require("./custom-extensions/customHighlight");

var _image = require("./custom-extensions/image");

var _indent = require("./custom-extensions/indent");

var _table = require("./custom-extensions/table");

var _interfaces = require("./interfaces");

var _markdown = require("./serializers/markdown");

var _excluded = ["underline", "image", "table", "link", "textAlign", "indent", "clipboard", "blockquote", "fontColor", "highlight", "textStyle"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getEditorCommands = function getEditorCommands(editor) {
  return {
    content: {
      set: function set(content, focusOnIt) {
        return focusOnIt ? editor.chain().focus().setContent(content).run() : editor.commands.setContent(content);
      },
      insert: function insert(position, content) {
        return editor.chain().focus().insertContentAt(position, content).run();
      },
      clear: function clear() {
        return editor.chain().focus().clearContent().run();
      }
    },
    focus: {
      focusAt: function focusAt(position) {
        editor.chain().focus(position).run();
      }
    },
    blockquote: {
      set: function set() {
        return editor.chain().focus().setBlockquote().run();
      },
      unset: function unset() {
        return editor.chain().focus().unsetBlockquote().run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleBlockquote().run();
      }
    },
    bold: {
      set: function set() {
        return editor.chain().focus().setBold().run();
      },
      unset: function unset() {
        return editor.chain().focus().unsetBold().run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleBold().run();
      }
    },
    bulletList: {
      set: function set() {
        return editor.chain().focus().wrapInList(_interfaces.Commands.bulletList).run();
      },
      unset: function unset() {
        return editor.chain().focus().wrapInList(_interfaces.Commands.bulletList).run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleBulletList().run();
      }
    },
    clearFormat: {
      set: function set() {
        return editor.chain().focus().unsetAllMarks().run();
      }
    },
    code: {
      set: function set() {
        return editor.chain().focus().setCode().run();
      },
      unset: function unset() {
        return editor.chain().focus().unsetCode().run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleCode().run();
      }
    },
    fontColor: {
      set: function set(colorCode, colorName, localization) {
        var _editor$state$selecti = editor.state.selection,
            from = _editor$state$selecti.from,
            to = _editor$state$selecti.to;
        editor.chain().focus().unsetSpanHighlight().updateAttributes('textStyle', {
          role: 'region'
        }).updateAttributes('textStyle', {
          'aria-roledescription': "".concat(colorName.toLowerCase(), " ").concat(localization.arialRoleFontText)
        }).updateAttributes('textStyle', {
          tabindex: '-1'
        }).setColor(colorCode).setTextSelection({
          from: from,
          to: to
        }).focus(to).run();
      },
      unset: function unset() {
        return editor.chain().focus().unsetColor().run();
      }
    },
    highlight: {
      set: function set(colorCode, colorName, localization) {
        var to = editor.state.selection.$to.pos;
        editor.chain().focus().setColor(_constants.HIGHLIGHT_DEFAULT_TEXT_COLOR_HEX).setSpanHighlight(colorCode).updateAttributes('textStyle', {
          role: 'region'
        }).updateAttributes('textStyle', {
          'aria-roledescription': "".concat(localization.colorWhiteTitleText, " ").concat(localization.arialRoleFontText, "; ").concat(colorName.toLowerCase(), " ").concat(localization.selectedText)
        }).updateAttributes('textStyle', {
          tabindex: '-1'
        }).focus(to).run();
      },
      unset: function unset() {
        var _editor$state$selecti2 = editor.state.selection,
            from = _editor$state$selecti2.from,
            to = _editor$state$selecti2.to; // set text color back to black when unsetting highlight

        editor.chain().focus().unsetColor().updateAttributes('textStyle', {
          role: null
        }).updateAttributes('textStyle', {
          'aria-roledescription': null
        }).updateAttributes('textStyle', {
          tabindex: null
        }).updateAttributes('textStyle', {
          class: null
        }).unsetSpanHighlight().setTextSelection({
          from: from,
          to: to
        }).focus().run();
      }
    },
    heading: {
      set: function set(level) {
        return editor.chain().focus().setHeading({
          level: level
        }).run();
      },
      toggle: function toggle(level) {
        return editor.chain().focus().toggleHeading({
          level: level
        }).run();
      }
    },
    horizontalRule: {
      set: function set() {
        return editor.chain().focus().setHorizontalRule().run();
      }
    },
    italic: {
      set: function set() {
        return editor.chain().focus().setItalic().run();
      },
      unset: function unset() {
        return editor.chain().focus().unsetItalic().run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleItalic().run();
      }
    },
    link: {
      set: function set(url) {
        return url && editor.chain().extendMarkRange('link').setLink({
          href: url
        }).run();
      },
      unset: function unset() {
        return editor.chain().extendMarkRange('link').unsetLink().run();
      },
      toggle: function toggle(url) {
        var _linkExtension$option;

        if (url === null) {
          return;
        }

        if (url === '') {
          editor.chain().extendMarkRange('link').unsetLink().run();
          return;
        }

        var linkExtension = editor.options.extensions.find(function (o) {
          return o.name === _extensionLink.Link.name;
        });

        if (linkExtension !== null && linkExtension !== void 0 && (_linkExtension$option = linkExtension.options) !== null && _linkExtension$option !== void 0 && _linkExtension$option.formatLink) {
          url = linkExtension.options.formatLink(url);
        }

        var _editor$state$selecti3 = editor.state.selection,
            from = _editor$state$selecti3.from,
            to = _editor$state$selecti3.to;

        if (from === to) {
          editor.chain().insertContentAt(from, url).setTextSelection({
            from: from,
            to: from + url.length
          }).setLink({
            href: url
          }).run();
        } else {
          editor.chain().extendMarkRange('link').setLink({
            href: url
          }).run();
        }

        var hasTextAfter = editor.view.state.doc.nodeAt(editor.view.state.selection.to + 1); // // Adding space if there's nothing after link.
        // // This is needed to stop extending link after adding it

        if (!hasTextAfter) {
          editor.chain().unsetHighlight().insertContentAt(editor.view.state.selection.to, ' ').setTextSelection({
            from: editor.view.state.selection.to,
            to: editor.view.state.selection.to + 1
          }).unsetAllMarks().focus().run();
        }
      }
    },
    listItem: {
      set: function set(listType) {
        return editor.chain().focus().liftListItem(listType).run();
      },
      toggle: function toggle(listType) {
        return editor.chain().focus().sinkListItem(listType).run();
      }
    },
    orderedList: {
      set: function set() {
        return editor.chain().focus().wrapInList(_interfaces.Commands.orderedList).run();
      },
      unset: function unset() {
        return editor.chain().focus().wrapInList(_interfaces.Commands.orderedList).run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleOrderedList().run();
      }
    },
    paragraph: {
      set: function set() {
        return editor.chain().focus().setParagraph().unsetAllMarks().run();
      }
    },
    underline: {
      set: function set() {
        return editor.chain().focus().setUnderline().run();
      },
      unset: function unset() {
        return editor.chain().focus().unsetUnderline().run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleUnderline().run();
      }
    },
    strike: {
      set: function set() {
        return editor.chain().focus().setStrike().run();
      },
      unset: function unset() {
        return editor.chain().focus().unsetStrike().run();
      },
      toggle: function toggle() {
        return editor.chain().focus().toggleStrike().run();
      }
    },
    history: {
      undo: function undo() {
        return editor.chain().focus().undo().run();
      },
      redo: function redo() {
        return editor.chain().focus().redo().run();
      }
    },
    clipboard: {
      paste: function paste() {
        return editor.commands.paste();
      },
      copy: function copy() {
        return editor.commands.copy();
      }
    },
    textAlign: {
      left: function left() {
        return editor.chain().focus().setTextAlign('left').run();
      },
      center: function center() {
        return editor.chain().focus().setTextAlign('center').run();
      },
      right: function right() {
        return editor.chain().focus().setTextAlign('right').run();
      },
      justify: function justify() {
        return editor.chain().focus().setTextAlign('justify').run();
      }
    },
    indent: {
      set: function set() {
        return editor.chain().focus().indent().run();
      },
      unset: function unset() {
        return editor.chain().focus().outdent().run();
      }
    },
    image: {
      set: function set(params) {
        return editor.chain().focus().setImage(params).run();
      }
    },
    table: {
      insert: function insert(rows, cols, ariaLabel) {
        editor.chain().focus().insertTableWithAriaLabel({
          ariaLabel: ariaLabel,
          rows: rows,
          cols: cols
        }).toggleHeaderColumn().focus().run();
        var firstCellPosition = editor.state.selection.$from.pos; //inserting &nbsp to announce empty cells to screen readers

        while (editor.can().goToNextCell()) {
          var from = editor.state.selection.$from.pos;
          editor.chain().insertContentAt(from, '<p>&nbsp</p>').goToNextCell().run();
        }

        editor.chain().insertContentAt(editor.state.selection.$from.pos, '<p>&nbsp</p>').focus(firstCellPosition).run();
      },
      edit: function edit(ariaLabel) {
        editor.chain().focus().updateTableAriaLabel({
          ariaLabel: ariaLabel
        }).focus().run();
      },
      addRowBelow: function addRowBelow() {
        var head = editor.state.selection.$head;
        var anchor = editor.state.selection.$anchor;
        var cellPosition = anchor || head;
        var colCount;

        for (var i = -3; i <= 0; i++) {
          var tableNode = cellPosition.node(i);

          if (tableNode && tableNode.type.name === 'table') {
            var _tableNode$firstChild;

            // colCount corresponds to the childCount in a row
            colCount = (_tableNode$firstChild = tableNode.firstChild) === null || _tableNode$firstChild === void 0 ? void 0 : _tableNode$firstChild.childCount;
            break;
          }
        } // Get the position of the first cell in the new row


        editor.chain().focus().addRowAfter().run();

        if (colCount) {
          for (var _i = 0; _i < colCount; _i++) {
            // Move cursor to the first cell of the next row
            editor.chain().focus().goToNextCell().run();
          }
        }
      },
      addColumnAfter: function addColumnAfter() {
        editor.chain().focus().addColumnAfter().run();
        editor.chain().focus().goToNextCell().run();
      },
      removeRow: function removeRow() {
        var _content$firstChild;

        var content = editor.view.state.selection.content().content;
        var head = editor.state.selection.$head;
        var anchor = editor.state.selection.$anchor;
        var cellPosition = anchor || head;
        var rowCount;
        var selectedRows = 0; // if selection is the entire table, delete table

        if (((_content$firstChild = content.firstChild) === null || _content$firstChild === void 0 ? void 0 : _content$firstChild.type.name) === 'table') {
          editor.chain().focus().deleteTable().run();
        } // find the number of rows in the selection


        content.forEach(function (node) {
          if (node && node.type.name === 'tableRow') {
            selectedRows += 1;
          }

          return selectedRows;
        }); // starting from .node(-3), traverse through the node tree to find table node
        // table may be at node(-3) or node(-2), depending on the editor selection

        for (var i = -3; i <= 0; i++) {
          var tableNode = cellPosition.node(i);

          if (tableNode && tableNode.type.name === 'table') {
            // rowCount refers to the childCount of a table node
            rowCount = tableNode.childCount;
            break;
          }
        } // delete table if there is a single row left or all rows are selected


        if (rowCount === 1 || selectedRows === rowCount) {
          editor.chain().focus().deleteTable().run();
        } else {
          editor.chain().focus().deleteRow().run();
        }
      },
      removeColumn: function removeColumn() {
        var _content$firstChild2, _content$firstChild3;

        var content = editor.view.state.selection.content().content;
        var head = editor.state.selection.$head;
        var anchor = editor.state.selection.$anchor;
        var cellPosition = anchor || head;
        var selectedColumns;
        var colCount; // if selection is the entire table, delete table

        if (((_content$firstChild2 = content.firstChild) === null || _content$firstChild2 === void 0 ? void 0 : _content$firstChild2.type.name) === 'table') {
          editor.chain().focus().deleteTable().run();
        } else if (((_content$firstChild3 = content.firstChild) === null || _content$firstChild3 === void 0 ? void 0 : _content$firstChild3.type.name) === 'tableRow') {
          var _content$firstChild4;

          selectedColumns = (_content$firstChild4 = content.firstChild) === null || _content$firstChild4 === void 0 ? void 0 : _content$firstChild4.childCount;
        }

        for (var i = -3; i <= 0; i++) {
          var tableNode = cellPosition.node(i);

          if (tableNode && tableNode.type.name === 'table') {
            var _tableNode$firstChild2;

            // colCount corresponds to the childCount in a row
            colCount = (_tableNode$firstChild2 = tableNode.firstChild) === null || _tableNode$firstChild2 === void 0 ? void 0 : _tableNode$firstChild2.childCount;
            break;
          }
        }

        if (colCount === 1 || colCount === selectedColumns) {
          editor.chain().focus().deleteTable().run();
        } else {
          editor.chain().focus().deleteColumn().run();
        }
      },
      toggleHeaderRow: function toggleHeaderRow() {
        return editor.chain().toggleHeaderRow().blur().run();
      },
      toggleHeaderColumn: function toggleHeaderColumn() {
        return editor.chain().toggleHeaderColumn().blur().run();
      },
      hasHeaderRow: function hasHeaderRow() {
        var cellPosition = editor.state.selection.$head || editor.state.selection.$anchor;
        var colCount;
        var hasHeaderRow = false;

        for (var i = -3; i <= 0; i++) {
          var tableNode = cellPosition.node(i);

          if (tableNode && tableNode.type.name === 'table') {
            var _tableNode$firstChild3, _tableNode$firstChild4;

            // colCount corresponds to the childCount in a row
            colCount = (_tableNode$firstChild3 = tableNode.firstChild) === null || _tableNode$firstChild3 === void 0 ? void 0 : _tableNode$firstChild3.childCount;
            var headerCount = 0;
            (_tableNode$firstChild4 = tableNode.firstChild) === null || _tableNode$firstChild4 === void 0 ? void 0 : _tableNode$firstChild4.content.forEach(function (child) {
              if (child.type.name === 'tableHeader') {
                headerCount += 1;
              }
            });
            hasHeaderRow = colCount === headerCount;
          }
        }

        return hasHeaderRow;
      },
      hasHeaderColumn: function hasHeaderColumn() {
        var cellPosition = editor.state.selection.$head || editor.state.selection.$anchor;
        var rowCount;
        var headerCount = 0;
        var tableNode;

        for (var i = -3; i <= 0; i++) {
          var node = cellPosition.node(i);

          if (node && node.type.name === 'table') {
            tableNode = node;
            rowCount = tableNode.childCount;
            break;
          }
        }

        if (tableNode) {
          tableNode.descendants(function (child) {
            if (child.type.name === 'tableRow') {
              if (child.firstChild && child.firstChild.type.name === 'tableHeader') {
                headerCount += 1;
              }
            }
          });
        }

        var hasHeaderColumn = rowCount === headerCount;
        return hasHeaderColumn;
      },
      canToggleHeaderRow: function canToggleHeaderRow() {
        return editor.can().toggleHeaderRow();
      },
      canToggleHeaderColumn: function canToggleHeaderColumn() {
        return editor.can().toggleHeaderColumn();
      },
      canInsertTable: function canInsertTable() {
        return !editor.can().deleteTable();
      },
      canEditTable: function canEditTable() {
        return editor.can().deleteTable();
      },
      canAddRowBelow: function canAddRowBelow() {
        return editor.can().addRowAfter();
      },
      canAddColumnAfter: function canAddColumnAfter() {
        return editor.can().addColumnAfter();
      },
      canRemoveRow: function canRemoveRow() {
        return editor.can().deleteRow();
      },
      canRemoveColumn: function canRemoveColumn() {
        return editor.can().deleteColumn();
      }
    }
  };
};

exports.getEditorCommands = getEditorCommands;

var instanceTransformer = function instanceTransformer(editor, getWordCount) {
  if (editor === null) return null;
  var commands = getEditorCommands(editor);
  return {
    isActive: function isActive(name, attributes) {
      return editor.isActive(name, attributes);
    },
    isEmpty: function isEmpty() {
      return editor.isEmpty;
    },
    isEditable: function isEditable() {
      return editor.isEditable;
    },
    isFocused: function isFocused() {
      return editor.isFocused;
    },
    focus: function focus() {
      return editor.view.dom.focus();
    },
    blur: function blur() {
      return editor.chain().blur().run();
    },
    on: function on() {
      return editor.on.apply(editor, arguments);
    },
    off: function off() {
      return editor.off.apply(editor, arguments);
    },
    getSelection: function getSelection() {
      var from = editor.view.state.selection.from;
      var to = editor.view.state.selection.to;
      var node = editor.view.state.selection.$head.nodeBefore;

      if (!node) {
        node = editor.view.state.selection.$head.nodeAfter;
      }

      return {
        from: from,
        to: to,
        node: node,
        text: editor.view.state.doc.textBetween(from, to)
      };
    },
    getJSON: function getJSON() {
      return editor.getJSON();
    },
    getHTML: function getHTML() {
      return editor.getHTML();
    },
    getText: function getText() {
      return editor.getText();
    },
    getMarkdown: function getMarkdown(escape) {
      return (0, _markdown.serializeToMarkdown)(editor, escape);
    },
    getAttributes: function getAttributes(name) {
      return editor.getAttributes(name);
    },
    getWordCount: getWordCount,
    destroy: function destroy() {
      return editor.destroy();
    },
    commands: commands
  };
};

exports.instanceTransformer = instanceTransformer;

var initializeEditorConfig = function initializeEditorConfig(controls, placeholder) {
  var options = _objectSpread({}, _constants.defaultControlsConfig);

  var extensions = [_extensionPlaceholder.default.configure({
    placeholder: placeholder
  })];
  var toolbarItems = (0, _deepmerge.default)(_constants.defaultControlsConfig, controls || {}); // Collecting options for extensions configuration

  for (var key in toolbarItems) {
    var control = toolbarItems[key];

    if (control && control.options) {
      options[key] = control.options;
    } else if (control === false) {
      options[key] = false;
    }
  }

  var underline = options.underline,
      image = options.image,
      table = options.table,
      link = options.link,
      textAlign = options.textAlign,
      indent = options.indent,
      clipboard = options.clipboard,
      blockquote = options.blockquote,
      fontColor = options.fontColor,
      highlight = options.highlight,
      textStyle = options.textStyle,
      starterKit = (0, _objectWithoutProperties2.default)(options, _excluded); // Starter kit extension with most of the features (https://tiptap.dev/api/extensions/starter-kit)

  extensions.push(_starterKit.default.configure(_objectSpread(_objectSpread({}, starterKit || {}), {}, {
    // Blockquote is set configured separately due to a command conflict
    blockquote: false
  })));

  if (textStyle !== false) {
    extensions.push(_customFontColor.CustomFontColor);
  }

  if (table !== false) {
    extensions.push(_table.CustomTable, _extensionTableRow.default, _extensionTableHeader.default, _extensionTableCell.default);
  }

  if (image !== false) {
    extensions.push(_image.Image);
  }

  if (fontColor !== false) {
    extensions.push(_extensionColor.Color.configure({
      types: ['textStyle']
    }));
  }

  if (highlight !== false) {
    // Higher priority to show text color on highlight
    extensions.push(_customHighlight.SpanHighlight);
    extensions.push(_extensionHighlight.default.extend({
      priority: 1000
    }).configure({
      multicolor: true
    }));
  }

  if (link !== false) {
    // There's no Link feature in Starter kit
    extensions.push(_extensionLink.default.configure(link));
  }

  if (underline !== false) {
    // There's no Underline feature in Starter kit
    extensions.push(_extensionUnderline.default.configure(underline));
  }

  if (clipboard !== false) {
    extensions.push(_clipboard.ClipboardExtension.configure(clipboard));
  } else {
    extensions.push(_clipboard.ClipboardExtension.configure({
      paste: false,
      copy: false,
      cut: false
    }));
  }

  if (textAlign !== false) {
    // There's no Text Align feature in Starter kit
    extensions.push(_extensionTextAlign.default.configure(_objectSpread({
      alignments: ['left', 'center', 'right'],
      defaultAlignment: 'left',
      types: ['heading', 'paragraph']
    }, textAlign)));
  }

  if (indent !== false) {
    // Custom Indent extension
    extensions.push(_indent.Indent.configure(indent));
  }

  if (blockquote !== false) {
    // Higher priority to resolve conflict with Bold command
    extensions.push(_extensionBlockquote.default.extend({
      priority: 101
    }).configure(blockquote));
  }

  return {
    extensions: extensions,
    toolbarItems: toolbarItems
  };
};

exports.initializeEditorConfig = initializeEditorConfig;

var setEditorReturnFocus = function setEditorReturnFocus(editorInstance) {
  return function () {
    return {
      focus: function focus() {
        editorInstance && editorInstance.focus();
      }
    };
  };
};

exports.setEditorReturnFocus = setEditorReturnFocus;